'use client';
export const dynamic = 'force-dynamic';
import Error500Comp from 'flender/500/500.index';
import { metaTag } from 'scripts';

export async function generateMetadata() {
    return metaTag({ title: 'Flender', description: 'Flender' });
}

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
    return <Error500Comp error={error} reset={reset} />;
}
